export enum CoaSetupMethod {
    template = "template",
    entity = "entity",
}
